export enum UnitEnum {
  KWH = "kWh",
  MWH = "MWh",
  PIECE = "piece"
}
